module.exports = __webpack_public_path__ + "static/media/edit-img.fa754ed3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit-img.svg
// module id = 910
// module chunks = 0